/*
 * @Author: your name
 * @Date: 2022-02-07 15:23:26
 * @LastEditTime: 2025-03-05 16:44:49
 * @LastEditors: kevinqq 350910378@qq.com
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \baishu_react_ui\src\components\BsySelectCheckBox\index.jsx
 */
import React from "react";
import BsyMsgBubble from "../BsyMsgBubble";
import { BsyUtils } from "../../utils/Utils";
import BsySelect, { TriggerComboPane } from "../BsySelect";

import "./index.css";
import { BsyConfig } from "../../global/BsyConfig";

export default class BsySelectCheckBox extends BsySelect {
  constructor(props) {
    super({
      hasSelectAll: !0,
      hasSelectEmpty: !1,
      emptySelectText: React.language("unfilled"),
      type: "combocheck",
      ...props,
    });

    this.page = 0;
    this.isAllSelect = false;
    this.isEditd = false; //记录数据是否产生变化
  }

  showCombo = (currentTarget) => {
    const {
      searchable,
      textField,
      valueField,
      allowBlank,
      hasSelectAll,
      hasSelectEmpty,
      emptySelectText,
      onCustomItem,
      colorEnable,
      async,
    } = this.options;
    const { items, value } = this.state;
    let width = this.element.current.offsetWidth;
    let that = this;
    this.isEditd = false;
    const newVal = value ? value : [];
    let height = this.element.current.offsetHeight < 32 ? 32 : this.element.current.offsetHeight;
    BsyMsgBubble({
      anchor: currentTarget,
      contentHTML: (ref) => {
        if (that.showLoadingHandle) {
          that.showLoadingHandle.closeAlter();
          that.showLoadingHandle = null;
        }
        return (
          <TriggerComboCheckPane
            colorEnable={colorEnable}
            valueSort={true}
            items={items}
            itemHeight={height}
            textField={textField}
            isMore={this.isMore}
            valueField={valueField}
            searchable={searchable}
            allowBlank={allowBlank}
            hasSelectEmpty={hasSelectEmpty}
            onCustomItem={onCustomItem}
            emptySelectText={emptySelectText}
            searchValue={that.searchValue}
            hasSelectAll={hasSelectAll}
            value={newVal}
            onSelect={(val) => {
              that.isEditd = true;
              that.selectItem(val);
            }}
            onSeach={this.onSeach}
            onMoreData={this.onMoreData}
          />
        );
      },
      text4Cancel: null,
      text4Ok: null,
      theme: this.props.theme,
      minWidth: "auto",
      width: width < 150 ? 150 : width,
      contentPadding: 0,
      edge: 200,
      hAdjust: 72,
      dockPosition: "left",
      onClose: function (e) {
        if (
          e &&
          e.target &&
          e.target.classList.contains("icon-dingding-guide-close")
        ) {
          that.setState(
            {
              value: "",
            },
            () => {
              BsyUtils.applyFunc(
                that,
                that.props.onStopEdit,
                ["", null, that],
                !1
              );
            }
          );
        } else {
          if (that.isEditd) {
            BsyUtils.applyFunc(
              that,
              that.props.onStopEdit,
              [that.state.value, null, that],
              !1
            );
          } else
            BsyUtils.applyFunc(
              that,
              that.props.onClose,
              [that.state.value, null, that],
              !1
            );
          // if (that.props.onStopEdit) {
          //     that.props.onStopEdit(that.state.value, null, that)
          // }

          //else {
          //     // if (that.props.onClose) {
          //     //     that.props.onClose(that.state.value, null, that)
          //     // }
          // }
        }
        that.setState({
          showList: !1,
        });
        return !1;
      },
    });
  };

  UNSAFE_componentWillReceiveProps(nextProps, nextContext) {
    //防止多次重复 setState
    let props = {};
    if (!BsyUtils.compare(this.state.value, nextProps.value)) {
      if (nextProps.value && Array.isArray(nextProps.value))
        props.value = [...nextProps.value];
      else {
        props.value = [];
      }
    }

    let items = nextProps.items || [];

    if (items && !BsyUtils.compare(items, this.state.items)) {
      this.options.value = this.value; // 先还原，周1重新调整逻辑 bobo 2024 01 23
      this.options.items = [...items];
      // props.items = items && [...items];
      const obj = this.getDefaultValue();
      props = { ...props, ...obj };
    }
    if (!BsyUtils.isObjectEmpty(props)) {
      this.setState({
        ...props,
      });
    }
  }

  clear = (event) => {
    event.stopPropagation();
    event.preventDefault();
    this.value = [];
    this.hasFocus = false;
    this.setState(
      {
        value: [],
        showList: false,
      },
      () => {
        BsyUtils.applyFunc(
          this,
          this.options.onStopEdit,
          [this.value, null, this],
          !1
        );
      }
    );
  };

  selectItem = (val) => {
    this.isEditd = true;
    this.value = [...val];
    this.setState({
      value: [...val],
    });
  };

  loadData = (skip, cb) => {
    const {
      async,
      hasLimit,
      limit,
      authGroupId,
      popupFormPath,
      asyncResultKey,
      textField,
      valueField,
      hasSelectEmpty,
      emptySelectText,
      rely,
    } = this.options;
    this.isMore = false;
    let b = this.options;
    if (BsyUtils.isObjectEmpty(async)) {
      let dd = [];
      if (BsyUtils.isObjectEmpty(this.searchValue) && hasSelectEmpty) {
        dd.push({
          [textField]: emptySelectText,
          [valueField]: BsyConfig().CONST.PARAMETER.EMPTY,
        });
      }
      this.setState(
        {
          items: dd,
          showList: false,
        },
        () => {
          cb && cb();
        }
      );
      return;
    }
    let filter = BsyUtils.applyFunc(
      this,
      this.props.onBeforeAsync,
      ["", null, this],
      !1
    );
    let data = async.data ? JSON.parse(JSON.stringify(async.data)) : {};
    if (rely) {
      if (rely.data) {
        if (rely.version) {
          data.rel = rely.data.rel;
        } else {
          data.rel = "and";
        }
        data.filter = {};
        if (data && !BsyUtils.isObjectEmpty(filter)) {
          data.filter = filter;
        }
      } else {
        //关联其他表数据，有筛选条件
        if (filter) {
          if (filter.rel == "and") {
            let isEmpty = false;
            BsyUtils.forEach(filter.cond, (key, item) => {
              if (["empty", "not_empty"].indexOf(item.method) > -1) {
                return;
              }
              if (BsyUtils.isObjectEmpty(item.value)) {
                isEmpty = true;
                return false;
              }
            });
            //有空就不请求
            if (isEmpty) data.filter = {};
            else data.filter = filter;
          } else if (filter.rel == "or") {
            let isEmpty = true;
            BsyUtils.forEach(filter.cond, (key, item) => {
              if (["empty", "not_empty"].indexOf(item.method) > -1) {
                isEmpty = false;
                return false;
              }
              if (!BsyUtils.isObjectEmpty(item.value)) {
                isEmpty = false;
                return false;
              }
            });
            //全部为空就不请求
            if (isEmpty) data.filter = {};
            else data.filter = filter;
          }
        } else {
          data.filter = null;
        }
      }
    }
    // else {
    //     data.filter = filter;
    // }

    // 快捷编辑使用 onBeforeAsync
    if (data && data.filter && BsyUtils.isObjectEmpty(data.filter)) {
      this.setState(
        {
          items: [],
          showList: false,
        },
        () => {
          cb && cb();
        }
      );
      return;
    }
    let n = {
      hasLimit: hasLimit,
      authGroupId: authGroupId,
      popupFormPath: popupFormPath ? [...popupFormPath] : undefined,
      ...data,
      limit: limit,
      skip: skip,
      jsplatform: data.filter
        ? data.filter.hasOwnProperty("cond")
          ? "React"
          : undefined
        : undefined,
      isNewFilter: data.filter
        ? data.filter.hasOwnProperty("cond")
          ? true
          : false
        : false,
    };
    if (["combo", "combocheck"].indexOf(this.options.type) > -1) {
      n.popupFormPath = undefined;
    }
    // n.widgetName =  b.orgWidgetName || b.widgetName;
    // n.subformName = b.subformName || b.subform;
    // n.designAppId = b.designAppId || window.FX.STATIC.APPID;
    // n.designEntryId = b.designEntryId;
    if (this.options.designAppId) {
      n.designAppId = this.options.designAppId;
      n.designEntryId = this.options.designEntryId;
      n.widgetName = b.orgWidgetName || b.widgetName;
      n.subformName = b.subformName || b.subform;
    }
    // subformName={i.designSubform}
    // orgWidgetName={i.designWidgetName}
    if (b.authGroupId !== undefined) {
      n.authGroupId = b.authGroupId;
    }

    n.hasDefault = b.hasDefault;
    if (n.hasOwnProperty("hasCurrentUser")) {
      if (
        BsyUtils.isObjectEmpty(n.filter) ||
        BsyUtils.isObjectEmpty(n.filter.cond)
      )
        n.hasCurrentUser = true;
      else {
        n.hasCurrentUser = false;
      }
    }
    if (!BsyUtils.isObjectEmpty(this.searchValue)) {
      n.keyword = this.searchValue + "";
      if (n.hasOwnProperty("hasCurrentUser")) {
        n.hasCurrentUser = false;
      }
    }

    React.axios(async.url, {
      ...n,
    })
      .then((res) => {
        BsyUtils.showAjaxTip(res.data, () => {
          let dd = [];

          if (
            BsyUtils.isObjectEmpty(this.searchValue) &&
            this.options.onAfterAsync
          ) {
            dd = this.options.onAfterAsync(dd);
          }

          BsyUtils.forEach(res.data[asyncResultKey], (a1, b1) => {
            if (BsyUtils.isString(b1) || BsyUtils.isNumber(b1)) {
              dd.push({
                [textField]: b1 + "",
                [valueField]: b1 + "",
                ...b1,
              });
            } else {
              if (b1.status == -2 || b1.status == -99) {
                dd.push({
                  ...b1,
                  [textField]: BsyUtils._toDeptUser(b1),
                  [valueField]: b1[valueField],
                });
              } else {
                dd.push({
                  ...b1,
                  [textField]: b1[textField],
                  [valueField]: b1[valueField],
                });
              }
            }
          });
          if (res.data[asyncResultKey])
            this.isMore = res.data[asyncResultKey].length === n.limit;
          let ddc = [];

          if (skip > 0) {
            if (this.state.items) ddc = [...this.state.items];
          }
          ddc = ddc.concat(dd);

          this.setState(
            {
              items: ddc,
            },
            () => {
              cb && cb();
            }
          );
        });
      })
      .catch((res) => {
        console.error(res);
      });
  };

  getValue = () => {
    return this.state.value;
  };

  onMoreData = (cb) => {
    this.page++;
    const { async, limit } = this.options;
    this.loadData(this.page * limit, () => {
      cb && cb(this.state.items, this.isMore);
    });
  };

  showItem = () => {
    const { items, value } = this.state;
    const { valueField, textField } = this.options;
    let text = [];

    if (!value) {
      items &&
        items.map((val) => {
          if (val.selected) {
            text.push(val[textField]);
          }
        });
      return text;
    } else {
      let ddmap = {};
      items &&
        items.map((val) => {
          ddmap[val[valueField]] = val;
        });
      if (value && Array.isArray(value)) {
        value.map((data) => {
          if (!ddmap[data]) {
            if (data === "fx_param_empty") {
              text.push(this.options.emptySelectText);
            } else text.push(data);
          } else {
            if (ddmap[data][textField]) {
              text.push(ddmap[data][textField]);
            } else {
              text.push(ddmap[data][valueField]);
            }
          }
        });
      }
    }

    return text;
  };
}

export class TriggerComboCheckPane extends TriggerComboPane {
  static defaultProps = {
    valueSort: false,
  };
  constructor(props) {
    super(props);

    this.state = {
      css: {},
      seaching: false,
      valueSort: props.valueSort,
      value:
        this.options.value || this.getDefaultValue(this.options.items || []),
      items: props.valueSort
        ? this.valueSort(this.options.items || [], this.options.value)
        : this.options.items || [],
      isMore: props.isMore || false,
    };
    let that = this;
    this.searchValue = this.options.searchValue;
    this.seachRef = React.createRef();
    this.listRef = React.createRef();
    this.isAllSelect = true;

    if (!this.state.value) {
      BsyUtils.forEach(this.state.items, (index, data) => {
        if (!data.selected) {
          that.isAllSelect = false;
          return false;
        }
      });
    } else {
      BsyUtils.forEach(this.state.items, (index, data) => {
        if (that.state.value.indexOf(data.value) === -1) {
          that.isAllSelect = false;
          return false;
        }
      });
    }
  }

  // getDefaultValue = (item) => {

  //     let val = []
  //     BsyUtils.forEach(item, (index, data) => {
  //         if (data.selected) {
  //             val.push(data.value)
  //         }
  //     })
  //     return val
  // }

  valueSort = (items, value) => {
    const { textField, valueField, hasSelectEmpty, emptySelectText } =
      this.options;
    let valueItem = [];
    let t = this.options;
    let ddd = [];
    if (BsyUtils.isObjectEmpty(t.searchValue) && hasSelectEmpty) {
      valueItem.push({
        [textField]: emptySelectText,
        [valueField]: BsyConfig().CONST.PARAMETER.EMPTY,
      });
    }

    let ddmap = {
      [BsyConfig().CONST.PARAMETER.EMPTY]: {
        [textField]: emptySelectText,
        [valueField]: BsyConfig().CONST.PARAMETER.EMPTY,
      },
    };
    let seletValue = [];
    for (let i = 0; i < items.length; i++) {
      let v = items[i];
      ddmap[v[valueField]] = v;
      if (value) {
        if (value.indexOf(v[valueField]) === -1) {
          ddd.push({
            ...v,
          });
        } else {
          if (
            !(
              BsyUtils.isObjectEmpty(t.searchValue) &&
              hasSelectEmpty &&
              items[i]._id === "fx_param_empty"
            )
          ) {
            valueItem.push({
              ...v,
            });
          }
        }
      } else {
        seletValue.push(v[valueField]);

        ddd.push({
          [valueField]: v[valueField],
          [textField]: v[textField],
          ...v,
        });
      }
    }
    if (seletValue.length) {
      value = [...seletValue];
    }
    if (value) {
      value.map((data) => {
        if (!ddmap[data]) {
          valueItem.push({
            [textField]: data,
            [valueField]: data,
            ...data,
          });
        }
      });
    }
    return [...valueItem, ...ddd];
  };

  onScroll = (e) => {
    const { isMore, page } = this.state;

    if (isMore) {
      if (this.listRef && this.listRef.current) {
        if (
          this.listRef.current.offsetHeight <=
          e.target.scrollTop + e.target.offsetHeight + 10
        ) {
          this.setState(
            {
              isMore: false,
            },
            () => {
              if (this.props.onMoreData) {
                this.props.onMoreData((items, isMore) => {
                  this.setState({
                    items: this.valueSort(items, this.state.value),
                    isMore: isMore,
                  });
                });
              }
            }
          );
        }
      }
    }
  };

  renderList = () => {
    const { textField, valueField, colorEnable } = this.options;
    const { seaching, value, items, isMore } = this.state;

    return (
      <>
        {!seaching &&
          items &&
          items.map((val) => {
            let selected = false;
            if (value) {
              if (value.indexOf(val[valueField]) > -1) {
                selected = true;
              } else {
                selected = false;
              }
            } else {
              selected = val.selected ? val.selected : false;
            }

            if (this.props.onCustomItem) {
              return (
                <div
                  key={val[valueField]}
                  // title={val[textField]}
                  onClick={this.selectItem(val[valueField])}
                  style={{
                    height: this.options.itemHeight
                  }}
                  className={
                    selected ? " item bsy-x-check select " : "item bsy-x-check "
                  }
                >
                  <i className="icon-blank"></i>
                  {this.props.onCustomItem(val)}
                </div>
              );
            }

            return (
              <div
                key={val[valueField]}
                title={val[textField]}
                onClick={this.selectItem(val[valueField])}
                style={{
                  height: this.options.itemHeight
                }}
                className={
                  selected ? " item bsy-x-check select " : "item bsy-x-check "
                }
              >
                <i className="icon-blank"></i>
                {colorEnable ? (
                  <span
                    className=" bsy-text-tag  middle single-line "
                    style={{
                      background: val.color,
                      color: "#fff",
                      border: "1px solid " + val.color,
                    }}
                    title={val[textField]}
                  >
                    {val[textField]}
                  </span>
                ) : (
                  <span className="text" title={val[textField]}>
                    {val[textField]}
                  </span>
                )}
              </div>
            );
          })}
        {/* {
                !seaching && isMore ?
                    <div className="loading" >{React.language('loading')}</div> : ''
            } */}
      </>
    );
  };

  selectItem = (val) => {
    return (e) => {
      e.stopPropagation();
      const { items, value } = this.state;
      const { textField, valueField } = this.options;
      let newValue = value ? [...value] : [];
      let d = newValue.indexOf(val);
      if (d === -1) {
        newValue.push(val);
      } else {
        newValue.splice(d, 1);
      }

      let isallSelect = true;
      items.map((v) => {
        let selected = newValue.indexOf(v[valueField]) > -1;
        if (!selected) {
          isallSelect = false;
        }
        return v;
      });
      this.isAllSelect = isallSelect;
      this.setState({ value: newValue }, () => {
        if (this.props.onSelect) {
          this.props.onSelect(this.state.value);
        }
      });
    };
  };

  onSelectAll = () => {
    const { isAllSelect } = this;
    const { items, value } = this.state;
    const { valueField } = this.options;
    let tmpvalue = value ? [...value] : [];
    let isallSelect = !isAllSelect;
    // let values = [];
    const newitems = items.map((data, index) => {
      let d = tmpvalue.indexOf(data[valueField]);
      if (isallSelect) {
        if (d == -1) {
          tmpvalue.push(data[valueField]);
        }
      } else {
        if (d > -1) {
          tmpvalue.splice(d, 1);
        }
      }
      return data;
    });
    this.isAllSelect = isallSelect;
    if (!this.isAllSelect) {
      tmpvalue = [];
    }
    this.setState(
      {
        items: [...newitems],
        value: tmpvalue,
      },
      () => {
        if (this.props.onSelect) {
          this.props.onSelect(this.state.value);
        }
      }
    );
  };

  render() {
    const { cssName, searchable, hasSelectAll } = this.options;
    const { seaching } = this.state;

    this.srkey = this.page === 0 ? "dfe" + new Date().getTime() : this.srkey;
    return (
      <div className={cssName}>
        {searchable ? (
          <div className="bsy-combo-search">
            <input
              ref={this.seachRef}
              onChange={this.seachItems}
              value={this.searchValue}
            ></input>
            <i className="icon-bsy-reportmenu-0"></i>
          </div>
        ) : (
          <></>
        )}
        <div
          className="bsy-select-list"
          key={this.srkey}
          onScroll={this.onScroll}
        >
          {seaching && (
            <div className="loading-text">
              <span>{React.language("searching")}</span>
            </div>
          )}
          <div style={{ overflow: "hidden" }} ref={this.listRef}>
            {!seaching && hasSelectAll ? (
              <div
                key={"all"}
                onClick={this.onSelectAll}
                style={{
                  height: this.options.itemHeight
                }}
                className={
                  "item bsy-x-check select-all field-meta " +
                  (this.isAllSelect ? "select" : "")
                }
              >
                <i className="icon-blank"></i>
                <span style={{ color: "#0265ff" }}>
                  {BsyUtils.isObjectEmpty(this.searchValue)
                    ? React.language("selectAll")
                    : React.language("selectAllSearchResult")}
                </span>
              </div>
            ) : (
              <></>
            )}
            {this.renderList()}
          </div>
        </div>
      </div>
    );
  }
}
